// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {RecordingTranscription} from '../search-index/recording-transcription.js'

export class AudioSearchIndex {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): AudioSearchIndex {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsAudioSearchIndex(bb: flatbuffers.ByteBuffer, obj?: AudioSearchIndex): AudioSearchIndex {
    return (obj || new AudioSearchIndex()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsAudioSearchIndex(bb: flatbuffers.ByteBuffer, obj?: AudioSearchIndex): AudioSearchIndex {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new AudioSearchIndex()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  recordingTitles(): string | null
  recordingTitles(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
  recordingTitles(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
  }

  transcriptionEntries(index: number, obj?: RecordingTranscription): RecordingTranscription | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset
      ? (obj || new RecordingTranscription()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!
        )
      : null
  }

  transcriptionEntriesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  version(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0
  }

  static startAudioSearchIndex(builder: flatbuffers.Builder) {
    builder.startObject(3)
  }

  static addRecordingTitles(builder: flatbuffers.Builder, recordingTitlesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, recordingTitlesOffset, 0)
  }

  static addTranscriptionEntries(builder: flatbuffers.Builder, transcriptionEntriesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, transcriptionEntriesOffset, 0)
  }

  static createTranscriptionEntriesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[]
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4)
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!)
    }
    return builder.endVector()
  }

  static startTranscriptionEntriesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4)
  }

  static addVersion(builder: flatbuffers.Builder, version: number) {
    builder.addFieldInt32(2, version, 0)
  }

  static endAudioSearchIndex(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // recording_titles
    builder.requiredField(offset, 6) // transcription_entries
    return offset
  }

  static createAudioSearchIndex(
    builder: flatbuffers.Builder,
    recordingTitlesOffset: flatbuffers.Offset,
    transcriptionEntriesOffset: flatbuffers.Offset,
    version: number
  ): flatbuffers.Offset {
    AudioSearchIndex.startAudioSearchIndex(builder)
    AudioSearchIndex.addRecordingTitles(builder, recordingTitlesOffset)
    AudioSearchIndex.addTranscriptionEntries(builder, transcriptionEntriesOffset)
    AudioSearchIndex.addVersion(builder, version)
    return AudioSearchIndex.endAudioSearchIndex(builder)
  }
}
